
<div class="radio-cards-container" style="max-width: 100%">
    <label class="radio-card-label-new" *ngIf="isAbutmentNarrowSelected" (click)="onAabutmentStep2Selection('Narrow healing space')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Anatomical connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep2','Narrow healing space')" value="Narrow healing space" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
            <app-magnifier [contentTemplate]="apppropphtmNarowHealing1234"></app-magnifier>
                <ng-template #apppropphtmNarowHealing1234>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                             <img width="auto" class="p-3" height="180"   src="abutment images/emergence/narrow-narrow.png" />
                        </div>
                        <div class="card-text">Narrow healing space</div>
                      <div class="card-subtext">curved inwards</div>
                     </div>
         </ng-template>
        </div>
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" *ngIf="isAbutmentNarrowSelected" (click)="onAabutmentStep2Selection('Straight')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Strong connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep2','Straight')" value="Straight" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
            <app-magnifier [contentTemplate]="apppropphtmStraight"></app-magnifier>
                <ng-template #apppropphtmStraight>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180"   src="abutment images/emergence/straight-narrow.png" />
                        </div>
                       <div class="card-text">Straight</div>
                      <div class="card-subtext">neutral - without curvature</div>
                     </div>
         </ng-template>
        </div>
       
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" *ngIf="isAbutmentNarrowSelected" (click)="onAabutmentStep2Selection('Convex')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Very strong connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep2','Convex')" value="Convex" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
            <app-magnifier [contentTemplate]="apppropphtmConvex"></app-magnifier>
                <ng-template #apppropphtmConvex>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180"  src="abutment images/emergence/convex-narrow.png"/>
                        </div>
                        <div class="card-text">Convex</div>
                       <div class="card-subtext">curved outwards</div>
                     </div>
         </ng-template>
        </div>
      
        <div class="radio-card-overlay"></div>
    </label>



    <label class="radio-card-label-new" *ngIf="isAbutmentWideSelected" (click)="onAabutmentStep2Selection('Narrow healing space')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Anatomical connection" class="hidden-radio-input" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
              <app-magnifier [contentTemplate]="apppropphtmNarrow121"></app-magnifier>
                <ng-template #apppropphtmNarrow121>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180"  src="abutment images/emergence/narrow-wide.png"/>
                        </div>
                         <div class="card-text">Narrow healing space</div>
                         <div class="card-subtext">curved inwards</div>
                     </div>
         </ng-template>
        </div>
       
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" *ngIf="isAbutmentWideSelected" (click)="onAabutmentStep2Selection('Straight')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Anatomical connection" class="hidden-radio-input" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
              <app-magnifier [contentTemplate]="apppropphtmStraight122"></app-magnifier>
                <ng-template #apppropphtmStraight122>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180" src="abutment images/emergence/straight-wide.png" />
                        </div>
                         <div class="card-text">Straight</div>
                        <div class="card-subtext">neutral - without curvature</div>
                     </div>
         </ng-template>
        </div>
       
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" *ngIf="isAbutmentWideSelected" (click)="onAabutmentStep2Selection('Convex')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Anatomical connection" class="hidden-radio-input" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
              <app-magnifier [contentTemplate]="apppropphtmConvex123"></app-magnifier>
                <ng-template #apppropphtmConvex123>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180" src="abutment images/emergence/convex-wide.png" />
                        </div>
                         <div class="card-text">Convex</div>
                         <div class="card-subtext">curved outwards</div>
                     </div>
         </ng-template>
        </div>
       
        <div class="radio-card-overlay"></div>
    </label>



     <label class="radio-card-label-new" *ngIf="isAbutmenthighlySelected" (click)="onAabutmentStep2Selection('Narrow healing space')" style="width:30%">
        <input type="radio" name="healing-emergence" 
            value="Anatomical connection" class="hidden-radio-input" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
            <app-magnifier [contentTemplate]="apppropphtmConvex12342"></app-magnifier>
                <ng-template #apppropphtmConvex12342>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img  width="auto" class="p-3" height="180" src="abutment images/emergence/narrow-highly.png"/>
                        </div>
                         <div class="card-text">Narrow healing space</div>
                     </div>
         </ng-template>
        </div>
        
        <div class="radio-card-overlay"></div>
    </label>
</div>